import { useEffect, useState } from "react";

const getDeviceType = (width) => {
  if (width < 768) return "Mobile";
  if (width >= 768 && width <= 1024) return "Tablet";
  return "Desktop";
};

const useDeviceType = () => {
  const [deviceType, setDeviceType] = useState(getDeviceType(window.innerWidth));

  useEffect(() => {
    const handleResize = () => {
      setDeviceType(getDeviceType(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceType;
};

export default useDeviceType;
